export const AnnouncementBar = ({ text }) => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-9 bg-[#29FF87] text-[#050805] font-body text-[10px] md:text-xs font-bold uppercase tracking-[0.2em] px-4 flex items-center justify-center gap-3 text-center whitespace-nowrap overflow-hidden" data-testid="announcement-bar">
      {text || "Free shipping over €200 · Lab-verified · Order via WhatsApp"}
    </div>
  );
};
